// AiProvenanceFooter — provenance row rendered under each candidate.
//
// Per WP-9 design rule: every candidate row must show provenance. Model
// name / rule version is rendered in the UI font; timestamp and dataset
// hash short are rendered in mono per
// `geosoft-platform-design-system/docs/DESIGN_INVENTORY.md` typography.

import { Icon, Stack, tokens } from "@/design";

export interface AiProvenanceFooterProps {
  readonly modelLabel: string | null;
  readonly timestamp: string | null;
  readonly datasetHashShort: string | null;
}

export function AiProvenanceFooter({
  modelLabel,
  timestamp,
  datasetHashShort,
}: AiProvenanceFooterProps) {
  return (
    <Stack
      direction="row"
      align="center"
      gap={2}
      style={{
        marginTop: tokens.space[2],
        flexWrap: "wrap",
        color: tokens.color.ink.muted,
      }}
      data-testid="ai-provenance-footer"
    >
      <Icon name="psychology" size={16} decorative />
      <span
        style={{
          fontFamily: tokens.font.family.ui,
          fontSize: tokens.font.role.engMeta.size,
          color: tokens.color.ink.secondary,
        }}
      >
        {modelLabel ?? "Model not declared"}
      </span>
      {timestamp ? (
        <span
          style={{
            fontFamily: tokens.font.family.mono,
            fontSize: tokens.font.role.engMono.size,
            color: tokens.color.ink.muted,
          }}
        >
          {timestamp}
        </span>
      ) : null}
      {datasetHashShort ? (
        <span
          style={{
            fontFamily: tokens.font.family.mono,
            fontSize: tokens.font.role.engMono.size,
            color: tokens.color.ink.muted,
          }}
        >
          dataset:{datasetHashShort}
        </span>
      ) : null}
    </Stack>
  );
}
